import React from 'react';
import PropTypes from 'prop-types';
import DealBuilderButton from './dealBuilderButton';

const DealBuilderPanel = ({
  financeAvailable,
  reservationAvailable,
  stockReference,
}) => {
  return (
    <div className="productheader__deal-builder">
      <ul
        className="ch-list ch-list--tick productheader__deal-builder-list ch-pa--2"
        id="deal-builder-button"
      >
        <li>Get an instant valuation on your trade-in</li>

        {financeAvailable && (
          <li>Get a customised finance quote perfect for you</li>
        )}
        {reservationAvailable && (
          <li>Reserve this car for a refundable deposit of £99</li>
        )}
      </ul>
      <div className="productheader__deal-builder-footer">
        <p className="ac-hidden--sm ch-mb--0 ch-text--bold ch-fs--3">
          A deal personalised for you
        </p>
        <DealBuilderButton
          additionalClasses="sm:ch-width--auto"
          stockReference={stockReference}
        />
      </div>
    </div>
  );
};

DealBuilderPanel.displayName = 'DealBuilderPanel';
DealBuilderPanel.propTypes = {
  financeAvailable: PropTypes.string,
  reservationAvailable: PropTypes.bool,
  stockReference: PropTypes.string,
};

export default DealBuilderPanel;
